import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import BankAccount from "./BankAccount";
import GridConfig from "./GridConfig";

export default class BankAccounts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'bankaccount',
            data: null,
            loading: true,
            configName: 'bankaccounts_grid',
            moduleName: 'حسابهای بانکی',
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    showTransactions(id) {
        this.showComponents({ component: <BankAccount Caller={this} Id={id} /> });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <BankAccount Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <BankAccount Caller={this} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "code", caption: "کد", show: true },
                { field: "name", caption: "عنوان حساب", show: true },
                { field: "number", caption: "شماره حساب", show: true },
                { field: "branch", caption: "شعبه", show: true },
                //{ field: "remain", caption: "گردش حساب", show: true },
                //{ field: "tashkhis", caption: "تشخیص", show: true },
                { field: "sheba", caption: "شماره شبا", show: false }, ,
                { field: "editDateString", caption: "تاریخ ثبت", show: false },
                { field: "createDateString", caption: "تاریخ بروزرسانی", show: false }        
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number' });
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.name}</a> } });
            if (f.field == 'number' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'branch' && f.show) t.push({ field: f.field, headerName: f.caption });
            //if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            //if (f.field == 'tashkhis' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'sheba' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });   
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable" style={{ "width": "85%" }}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="mr-10">
                                <div className="center-block">
                                    {this.getToolBar()}
                                    {this.renderAgGrid({
                                        columnDefs: this.getColumns()
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}